/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useContext, useEffect } from "react";
import { DateTimePicker } from "@progress/kendo-react-dateinputs";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { process } from "@progress/kendo-data-query";
import { Loader } from "@progress/kendo-react-indicators";
import { isOperationAllowed, showToast } from "utils/helper";
import { UserContext } from "utils/reducers/user";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Button,
  Card,
  CardContent,
  Combobox,
  DatePicker,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@repo/ui";
import Layout from "components/layout";
import { Link } from "react-router-dom";
import {
  useChangeOperationalWindow,
  useConfirmEndOfDay,
  useGetEndOfDayRequests,
} from "utils/apis/end-of-day.api";
import { useGetCashCenters } from "utils/apis/lookups.api";
import { PREV_DAY_DATE } from "utils/constant";
import { formatDate } from "date-fns";
import { Permissions } from "utils/enums";

const currentDate = new Date();

const initialDataState = { sort: [{ field: "code", dir: "asc" }] };

function EndOfCashCenterDay() {
  const user = useContext(UserContext);

  const [ddlCashCenters, setDdlCashCenters] = useState("");
  const [operationDate, setOperationDate] = useState(currentDate);
  const [nextOperationDate, setNextOperationDate] = useState(currentDate);
  const [startDateTime, setStartDateTime] = useState(currentDate);
  const [endDateTime, setEndDateTime] = useState(currentDate);

  const [openRequests, setOpenRequests] = useState([]);
  const [opsStartDateTime, setOpsStartDateTime] = useState("");
  const [opsEndDateTime, setOpsEndDateTime] = useState("");
  const [dataState, setDataState] = useState<any>(initialDataState);

  const [isOperationChange, setIsOperationChange] = useState(false);
  const [isEODOpen, setIsEODOpen] = useState(false);

  const [btnConfirmDisabled, setBtnConfirmDisabled] = useState(false);
  const { data: cashCenters, isSuccess: cashCenterSuccess } =
    useGetCashCenters();

  useEffect(() => {
    if (cashCenterSuccess) {
      const userCcId = user.CashCenterId;
      const userCc = cashCenters.find(
        (ccl: any) => ccl.cashCenterId === userCcId
      );
      if (userCc) {
        setDdlCashCenters(userCc.cashCenterId);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cashCenterSuccess]);

  const { data: requestsData, isPending: loaderPanel } = useGetEndOfDayRequests(
    {
      cashCenterId: ddlCashCenters || user.CashCenterId,
      operationDate: formatDate(
        operationDate || currentDate,
        "yyyy-MM-dd'T'00:00:00.000'Z'"
      ),
    }
  );

  useEffect(() => {
    if (requestsData) {
      const { requests, endOfDayConfirmed, opsStartDateTime, opsEndDateTime } =
        requestsData;

      if (endOfDayConfirmed) {
        setBtnConfirmDisabled(true);
      } else {
        // if (requests.length >= 0) setBtnConfirmDisabled(true);
        // else setBtnConfirmDisabled(false);
        const closedRequests = requests.filter(
          (req: any) => req.status === "Closed" || req.status === "Cancelled"
        );

        if (requests.length > 0) {
          if (closedRequests.length === requests.length)
            setBtnConfirmDisabled(false);
          else setBtnConfirmDisabled(true);
        }
      }

      const openRequests = requests.map((req: any) => ({
        requestId: req.requestId,
        jobNo: req.jobNo,
        customer: req.customer,
        locationId: req.locationId,
        locationName: req.locationName,
        locationType: req.locationType,
        routeNo: req.routeNo,
        serviceType: req.serviceType,
        jobType: req.jobType,
        serviceDate: req.serviceDate,
        status: req.status,
        priority: req.priority,
        pendingReason: req.pendingReason,
        remarks: req.remarks,
      }));

      setOpenRequests(openRequests);

      setOpsStartDateTime(opsStartDateTime);
      setOpsEndDateTime(opsEndDateTime);
    }
  }, [requestsData]);

  const onDdlCashCentersChanged = (value: string) => {
    setDdlCashCenters(value);
  };

  const onOperationDateChanged = (value: Date) => {
    setOperationDate(value);
  };

  const onNextOperationDateChanged = (value: Date) => {
    setNextOperationDate(value);
  };

  const onStartDateTimeChanged = (event: any) => {
    const value = event.value;
    setStartDateTime(value);
  };

  const onEndDateTimeChanged = (event: any) => {
    const value = event.value;
    setEndDateTime(value);
  };

  function PriorityButtonCell({ dataItem }: any) {
    const { priority } = dataItem;

    let btnColor = "bg-green-500";

    if (priority === "High") btnColor = "bg-red-500";

    if (priority === "Low") btnColor = "bg-yellow-500";

    return (
      <td className={btnColor} style={{ border: "solid white 0.0625rem" }}>
        <span className="text-white text-center font-semibold block w-full">
          {priority}
        </span>
      </td>
    );
  }

  const {
    mutate: changeOperationalWindow,
    isSuccess: changeOperationSuccess,
    isPending: changeOperationPending,
  } = useChangeOperationalWindow();

  const handleConfirmChangeOperationWindow = () => {
    if (!ddlCashCenters) {
      showToast("error", "Please select cash center.");
      return;
    }
    setIsOperationChange(true);
  };

  const handleChangeOperationWindow = () => {
    const cashCenterId = ddlCashCenters;

    const endOfDayDto = {
      cashCenterId,
      operationDate: formatDate(
        operationDate || currentDate,
        "yyyy-MM-dd'T'00:00:00.000'Z'"
      ),
      dayStart: formatDate(
        startDateTime || currentDate,
        "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"
      ),
      dayEnd: formatDate(
        endDateTime || currentDate,
        "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"
      ),
    };

    changeOperationalWindow(endOfDayDto);
  };

  useEffect(() => {
    if (changeOperationSuccess) {
      setIsOperationChange(false);
    }
  }, [changeOperationSuccess]);

  const {
    mutate: confirmEndOfDay,
    isSuccess: endOfDaySuccess,
    isPending: endOfDayPending,
  } = useConfirmEndOfDay();

  const handleConfirmEOD = () => {
    if (!ddlCashCenters) {
      showToast("error", "Please select cash center.");
      return;
    }
    setIsEODOpen(true);
  };

  const handleEOD = () => {
    if (!ddlCashCenters) {
      showToast("error", "Please select cash center.");
      return;
    }

    const cashCenterId = ddlCashCenters;

    const endOfDayDto = {
      cashCenterId,
      nextOperationDate: formatDate(
        nextOperationDate || currentDate,
        "yyyy-MM-dd'T'00:00:00.000'Z'"
      ),
    };

    confirmEndOfDay(endOfDayDto);
  };

  useEffect(() => {
    if (endOfDaySuccess) {
      setIsEODOpen(false);
    }
  }, [endOfDaySuccess]);

  return (
    <Layout>
      <Breadcrumb className="mt-5 mx-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <Link to="/dashboard">Home</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>End Of Day </BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
      <Card className="mx-4 mt-5">
        <CardContent className="pt-6">
          <div className="flex gap-4 items-end">
            <div className="flex-1">
              <label className="font-semibold">Current Operations Window</label>
              <Button variant="outline" type="button" className="w-full">
                {`${opsStartDateTime} to ${opsEndDateTime}`}
              </Button>
            </div>

            <div className="flex-1">
              <label className="font-semibold">
                Select Operations Day Start
              </label>
              <DateTimePicker
                className="h-10"
                value={startDateTime}
                onChange={onStartDateTimeChanged}
              />
            </div>

            <div className="flex-1">
              <label className="font-semibold">Select Operations Day End</label>
              <DateTimePicker
                className="h-10"
                value={endDateTime}
                onChange={onEndDateTimeChanged}
              />
            </div>

            {isOperationAllowed(
              Permissions.OperationWindow,
              Permissions.Edit
            ) ? (
              <div className="flex-1">
                <Button
                  className="w-full"
                  variant="secondary"
                  onClick={handleConfirmChangeOperationWindow}
                >
                  Change Operational Window
                </Button>
              </div>
            ) : null}
          </div>

          <div className="border-b my-3 bg-accent" />

          <div className="flex gap-4 items-end">
            <div className="flex-1">
              <label className="font-semibold">Cash Center</label>
              <Combobox
                value={ddlCashCenters}
                data={cashCenters?.map((st: any) => ({
                  value: st.cashCenterId,
                  label: st.name,
                }))}
                placeholder="Select Cash Center"
                setValue={onDdlCashCentersChanged}
              />
            </div>

            <div className="flex-1">
              <label className="font-semibold">Operations Date</label>
              <DatePicker
                className="w-100"
                placeholder="Select Operation Date"
                selectedDate={operationDate}
                onSelectDate={onOperationDateChanged}
              />
            </div>

            <div className="flex-1">
              <label className="font-semibold">Next Operations Date</label>
              <DatePicker
                disabled={(date) => date < PREV_DAY_DATE}
                className="w-full"
                placeholder="Select Next Operation Date"
                selectedDate={nextOperationDate}
                onSelectDate={onNextOperationDateChanged}
              />
            </div>

            {isOperationAllowed(Permissions.EndOfDay, Permissions.Edit) ? (
              <div className="flex-1">
                <Button
                  variant="secondary"
                  className="w-full"
                  disabled={btnConfirmDisabled}
                  onClick={handleConfirmEOD}
                >
                  Confirm End of Day
                </Button>
              </div>
            ) : null}
          </div>

          <div className="border-b my-3 bg-accent" />

          {loaderPanel ? (
            <div className="text-center">
              <Loader size="large" type="pulsing" />
            </div>
          ) : null}

          <Grid
            sortable
            filterable
            data={process(
              openRequests.map((req: any) => ({
                ...req,
              })),
              dataState
            )}
            {...dataState}
            onDataStateChange={(e: any) => {
              setDataState(e.dataState);
            }}
          >
            <Column
              field="jobNo"
              title="Job No"
              className="text-center"
              width="100"
            />
            <Column field="customer" title="Customer" width="150" />
            <Column field="locationId" title="Location Id" width="120" />
            <Column field="locationName" title="Location Name" width="150" />
            <Column field="locationType" title="Location Type" width="150" />
            <Column field="routeNo" title="Route No" width="100" />
            <Column field="serviceType" title="Service Type" width="120" />
            <Column field="jobType" title="Job Type" width="120" />
            <Column
              width="150"
              field="serviceDate"
              title="Service Date"
              className="text-center"
            />
            <Column field="status" title="Status" width="120" />
            <Column field="pendingReason" title="Pending Reason" />
            <Column field="remarks" title="Remarks" />
            <Column
              width="80"
              title="Priority"
              className="text-center"
              cell={PriorityButtonCell}
              filterable={false}
            />
          </Grid>
        </CardContent>
      </Card>
      <Dialog open={isOperationChange} onOpenChange={setIsOperationChange}>
        <DialogContent
          className="max-w-[650px] "
          disableOutsideClick={changeOperationPending}
        >
          <DialogHeader>
            <DialogTitle>Confirmation</DialogTitle>
          </DialogHeader>
          <DialogDescription className="p-4 overflow-auto max-h-[80vh]">
            <p className="text-black">
              Are you sure you want to change operational window?
            </p>
            <div className="flex gap-4 justify-end mt-4">
              <Button
                variant="outline"
                onClick={() => {
                  setIsOperationChange(false);
                }}
                disabled={changeOperationPending}
              >
                Cancel
              </Button>
              <Button
                disabled={changeOperationPending}
                isLoading={changeOperationPending}
                variant="secondary"
                onClick={handleChangeOperationWindow}
              >
                Confirm
              </Button>
            </div>
          </DialogDescription>
        </DialogContent>
      </Dialog>

      <Dialog open={isEODOpen} onOpenChange={setIsEODOpen}>
        <DialogContent
          className="max-w-[650px] "
          disableOutsideClick={endOfDayPending}
        >
          <DialogHeader>
            <DialogTitle>Confirmation</DialogTitle>
          </DialogHeader>
          <DialogDescription className="p-4 overflow-auto max-h-[80vh]">
            <p className="text-black">
              Are you sure you want to perform End of Day and next operation
              date selected?
            </p>
            <div className="flex gap-4 justify-end mt-4">
              <Button
                variant="outline"
                onClick={() => {
                  setIsEODOpen(false);
                }}
                disabled={endOfDayPending}
              >
                Cancel
              </Button>
              <Button
                disabled={endOfDayPending}
                isLoading={endOfDayPending}
                variant="secondary"
                onClick={handleEOD}
              >
                Confirm
              </Button>
            </div>
          </DialogDescription>
        </DialogContent>
      </Dialog>
    </Layout>
  );
}

export default EndOfCashCenterDay;
